// The card's aggregator: the reader's rating over the period, one series per time class played, in time order. Registered with
// the game store by this plugin's setup; the store runs it over the last
// 30 days.
import { type RatingSeries } from '@chess/api-insights';
import { aggregatorId, collect, TIME_CLASSES, type Accumulator, type Aggregator } from '@chess/api-model';

export class RatingSeriesAggregator implements Aggregator<RatingSeries[]> {
  readonly id = aggregatorId('rating-series');

  start(): Accumulator<RatingSeries[]> {
    return collect((games) => {
      const series: RatingSeries[] = [];
      for (const timeClass of TIME_CLASSES) {
        const points = games
          .filter((g) => g.timeClass === timeClass && g.readerRating !== undefined)
          .sort((a, b) => a.playedAt - b.playedAt)
          .map((g) => ({ at: g.playedAt, rating: g.readerRating! }));
        if (points.length) series.push({ timeClass, points });
      }
      return series;
    });
  }
}
